import { render, staticRenderFns } from "./NewsPostComponent.vue?vue&type=template&id=b898998a&scoped=true&"
import script from "./NewsPostComponent.vue?vue&type=script&lang=js&"
export * from "./NewsPostComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewsPostComponent.vue?vue&type=style&index=0&id=b898998a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b898998a",
  null
  
)

export default component.exports